<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter, RouterLink } from 'vue-router'
import { dataManager, type ResourceData } from '@/dataManager'
import ResourceCard from '@/components/ResourceCard.vue'

const emit = defineEmits<{
  (e: 'backButton', backUrl: string|null): void
}>()

const router = useRouter()
const dm = dataManager.getInstance()

onMounted(() => {
  console.log("ResourceCatalog mounted")
  emit('backButton', '/')
})

type ResourceGroup = {
  title: string
  recommendedResources: ResourceData[]
}

const allResourceGroups = calcAllResourceGroups()

function calcAllResourceGroups(): ResourceGroup[] {
  const resourceGroups: ResourceGroup[] = []
  dm.getMainQuestionnaireList().forEach((questionnaire) => {
    resourceGroups.push({
      title: dm.extractTitles(questionnaire.title)[0],
      recommendedResources: dm.getAllResources(questionnaire.id)
    })
  })
  return resourceGroups
}

</script>

<template>
  <h2>Listado completo de recursos</h2>

  <div v-for="(recommendationGroup, index) in allResourceGroups">
    <details :open="index == 0">
      <summary>{{ recommendationGroup.title }}</summary>
      <ResourceCard v-for="resource in recommendationGroup.recommendedResources" :resource="resource" />
      <p v-if="recommendationGroup.recommendedResources.length <= 1">Estamos trabajando para ofrecerte más recursos próximamente.</p>
    </details>
  </div>

  <RouterLink to="/" class="button">OK</RouterLink>
</template>

<style scoped>
h2 {
  text-align: center;
}
div {
  width: 100%;
  max-width: var(--content-max-width);
}
details {
  margin-top: 15px;
}
summary {
  font-family: var(--title-font);
  color: var(--secondary-color);
  font-size: 13pt;

}
</style>
